import i18n from 'i18next';

import { DashboardVehicle } from '../types/DashboardVehicle';
import { getVehicleBrand } from './getVehicleBrand';
import { isVehicleApplicationInSubmission } from './isVehicleApplicationInSubmission';

export const getVehicleApplicationDescription = (
  vehicle: DashboardVehicle,
): string => {
  if (isVehicleApplicationInSubmission(vehicle)) {
    return i18n.t('applicationDescription.inSubmission');
  }

  const brand = getVehicleBrand(vehicle);
  const id = vehicle.application?.autopayNumber?.substring(6);

  if (!id) {
    return i18n.t('applicationDescription.brand', { brand });
  }

  return i18n.t('applicationDescription.brandWithId', { brand, id });
};
